<p-dialog 
    [(visible)]="visible" 
    [draggable]="false" 
    [modal]="true" 
    showEffect="fade"
    [style]="{width: '28vw', 'min-width': '380px', 'max-width': '450px'}" 
    [breakpoints]="{'960px': '70vw', '640px': '90vw'}" 
    class="dialogPage" 
    [closable]="false"
    (onHide)="closeDialog()">
    
    <ng-template pTemplate="header">
        <span class="font-semibold text-lg">{{ 'Key.SuperAdminVerification' | translate }}</span>
    </ng-template>
    <div class="p-4">
        <div class="col-12 flex justify-content-center mb-1">
            <i class="pi pi-mobile text-primary-500 text-7xl"></i>
        </div>
        <div class="col-12 text-center mb-2" *ngIf="!otpSent">
            <p class="text-600 text-base m-0">
                {{ 'Key.PleaseEnterYourPhoneNumber' | translate }}
            </p>
        </div>
        <form [formGroup]="superAdminForm" class="col-12">
            <div class="mb-2">
                <div class="flex mb-2">
                    <label for="phoneNumber" class="text-title text-sm">
                        {{ 'Key.PhoneNumber' | translate }}
                    </label>
                    <div class="text-red-500 flex ml-1">
                        <p class="m-0" *ngIf="superAdminForm.get('phoneNumber').touched && 
                                  superAdminForm.get('phoneNumber').errors?.['required']">
                            *
                        </p>
                    </div>
                </div>
                <input 
                    id="phoneNumber"
                    type="text" 
                    pInputText 
                    formControlName="phoneNumber"
                    [disabled]="otpSent"
                    class="w-full p-3"
                    placeholder="+90xxxxxxxxxx"
                    [class.p-invalid]="checkSuperAdminFormValidity('phoneNumber')"
                />
                <div class="alert mt-1" style="min-height: 1.25rem;">
                    <small class="error-message" 
                       *ngIf="checkSuperAdminFormValidity('phoneNumber')">
                        {{ getSuperAdminFormValidityMessage('phoneNumber') }}
                    </small>
                </div>
            </div>
            <div class="mb-2" *ngIf="!otpSent">
                <button 
                    pButton 
                    pRipple 
                    type="button"
                    label="{{ 'Key.SendCode' | translate }}"
                    icon="pi pi-send"
                    iconPos="left"
                    class="w-full"
                    style="padding: 0.65rem 1rem; font-size: 0.95rem;"
                    [disabled]="superAdminForm.get('phoneNumber').invalid"
                    (click)="sendOtpCode()">
                </button>
            </div>
            <ng-container *ngIf="otpSent">
                <div class="flex flex-wrap justify-content-center mb-2">
                    <ng-otp-input 
                        #otpInput
                        class="pb-2 flex justify-content-center align-items-center w-full"
                        (onInputChange)="onOtpChange($event)" 
                        [config]="otpCodeConfig">
                    </ng-otp-input>
                </div>
                <div class="alert mb-2" style="min-height: 1.25rem;" *ngIf="superAdminForm.get('otpCode').touched">
                    <small class="error-message text-center block" 
                       *ngIf="checkSuperAdminFormValidity('otpCode')">
                        {{ getSuperAdminFormValidityMessage('otpCode') }}
                    </small>
                </div>
                <div class="text-center mb-3">
                    <div class="flex justify-content-center align-items-center">
                        <i class="pi pi-clock mr-2" 
                           [ngStyle]="getDynamicTimerStyle()" 
                           class="text-base"></i>
                        <span [ngStyle]="getDynamicTimerStyle()" class="text-base">
                            {{ otpTimer }} {{ "Key.sn" | translate }}
                        </span>
                    </div>
                </div>
                <div class="flex gap-2 mb-1">
                    <button 
                        pButton 
                        pRipple 
                        type="button"
                        label="{{ 'Key.Verify' | translate }}"
                        icon="pi pi-check"
                        iconPos="left"
                        class="flex-1 p-3 p-button-sm"
                        [disabled]="isOtpVerifying || superAdminForm.invalid"
                        [loading]="isOtpVerifying"
                        (click)="verifySuperAdminLogin()">
                    </button>
                    
                    <button 
                        pButton 
                        pRipple 
                        type="button"
                        label="{{ 'Key.Resend' | translate }}"
                        icon="pi pi-replay"
                        iconPos="left"
                        class="p-button-outlined flex-1 p-3"
                        [disabled]="otpTimer > 0"
                        (click)="resendOtpCode()">
                    </button>
                </div>
                <div class="text-center mt-2" *ngIf="otpTimer > 0">
                    <small class="text-500 text-sm">
                        {{ 'Key.YouCanResendAfterTimerEnds' | translate }}
                    </small>
                </div>
            </ng-container>
        </form>
    </div>
</p-dialog>
